// extracted by mini-css-extract-plugin
export default {"ghost":"ghost-0404","caret":"caret-f858","blink":"blink-3768","mark":"mark-e7ed"};